import { Field } from '../fields/Field';
import { Field as FieldType } from '../fieldtypes/Field';
import type { IFIXParser } from '../IFIXParser';
import type { Message } from '../message/Message';
import { heartBeat } from '../messagetemplates/MessageTemplates';

/**
 * Handles the TestRequest message in a FIX session.
 * This function processes the TestRequest message and responds with a Heartbeat message.
 * If the TestRequest contains a TestReqID, it is included in the Heartbeat response.
 *
 * @param {IFIXParser} parser - The FIX parser instance handling the session
 * @param {Message} message - The TestRequest message to process
 */
export const handleTestRequest = (parser: IFIXParser, message: Message): void => {
    let heartBeatMessage: Message = heartBeat(parser);
    const testReqIdValue: string | undefined = (message.getField(FieldType.TestReqID)?.value as string) ?? null;
    if (testReqIdValue !== null && testReqIdValue !== '') {
        const testReqId: Field = new Field(FieldType.TestReqID, testReqIdValue);
        heartBeatMessage = heartBeat(parser, testReqId);
        parser.send(heartBeatMessage);
        parser.logger.log({
            level: 'info',
            message: `${
                parser.parserName
            } (${parser.protocol?.toUpperCase()}): >> responded to TestRequest with Heartbeat<TestReqID=${testReqIdValue}>`,
            fix: heartBeatMessage.encode('|'),
        });
    } else {
        parser.send(heartBeatMessage);
        parser.logger.log({
            level: 'info',
            message: `${parser.parserName} (${parser.protocol?.toUpperCase()}): >> responded to TestRequest with Heartbeat`,
            fix: heartBeatMessage.encode('|'),
        });
    }
};
